<!-- 地图 -->
<template>
    <div id="">
        <span id="city"></span>
        <div class="search-ctn">
            <el-input v-model="addressText" placeholder="必须输入城市名如(广州市)或更详细地址"></el-input>
            <el-button @click="getAddressLoction" type="primary">搜索</el-button>
        </div>
        <div class="address-text">{{markerLocation.name}}</div>
        <div class="address-text">{{markerLocation.address}}</div>
        <div></div>
        <div id="container"></div>
        <div class="dialog-footer">
            <el-button @click="cancelMap">取 消</el-button>
            <el-button type="primary" @click="sendLocation">确 定</el-button>
        </div>
        <el-dialog
                width="800px"
                title="门店详情"
                :visible.sync="innerVisible"
                append-to-body>
            <div class="s0-1">
                <div class="up-logo">
                    <div style="width: 200px;margin-right: 20px">
                        <div class="preview">
                            <img :src="downloadUrl+chosenShopMsg.LogoUrl" alt="">
                        </div>
                    </div>
                </div>
                <div class="formData">
                    <div class="company-title">
                        <div class="company-name">
                            {{chosenShopMsg.Cn}}
                        </div>
                    </div>
                    <div class="msg-line">
                        <div class="msg-cell">
                            <div class="key">英文名</div>
                            <div class="value">{{chosenShopMsg.En}}</div>
                        </div>
                    </div>
                    <div class="msg-line">
                        <div class="msg-cell">
                            <div class="key">简称</div>
                            <div class="value">{{chosenShopMsg.Abbr}}</div>
                        </div>
                    </div>
                    <div class="msg-line">
                        <div class="msg-cell">
                            <div class="key">法人</div>
                            <div class="value">{{chosenShopMsg.LegalPerson}}</div>
                        </div>
                    </div>
                    <div class="msg-line">
                        <div class="msg-cell">
                            <div class="key">主要经营配件</div>
                            <div class="value">
                                <div class="carTypeItem carTypeItem-show" v-for="(item) in chosenShopMsg.MainManageAutoParts" :key="item">
                                    {{item}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="msg-line">
                        <div class="msg-cell">
                            <div class="key">主要经营车型</div>
                            <div class="value">
                                <div class="carTypeItem carTypeItem-show" v-for="(item) in chosenShopMsg.MainManageSeries" :key="item">
                                    {{item}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="text-align: right">
                <el-button type="primary" @click="reservationShop">预约</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: '',
        components: {

        },
        props:['locationMsg'],
        data(){
            return {
                downloadUrl:this.$util.QN_URL_BASE,
                chosenShopMsg:{},
                innerVisible:false,
                downUrl: this.$util.QN_URL_BASE, // 下载
                addressText:'',
                markerLocation:{},
                searchService:null,
                center:null,
                citylocation:null,
                marker:null,
                latlngs:[],
                shopList:[],
                infoWin:null,
            }
        },
        mounted(){
            this.init()
        },
        methods:{
            cancelMap(){
                this.$emit('clearMap')
            },
            sendLocation(){
                if(this.markerLocation.address){
                    this.$emit('sendLocation',this.markerLocation)
                }
                else {
                    this.$util.warningMsg('请选择要发送的地址')
                }
            },
            init() {
                window.showShopDetails = (id)=>{
                    this.shopDetailsVisible(id)
                }
                // 打开用户发过来的定位信息
                if (this.locationMsg){
                    this.seeAddress()
                }
                else {
                // 给车主发定位
                    this.sendAddress()
                }
            },
            // 预约门店
            reservationShop(){
                this.$emit('createRReservations',this.chosenShopMsg.Id)
            },
            // 显示汽修厂的详情信息
            shopDetailsVisible(id){
                this.innerVisible = true
                this.axios.get('/Common/GetRepairShopDetail',{
                    params:{
                        entpId:id
                    }
                }).then((res)=>{
                    let data  =  res.data.data
                    data.MainManageSeries = data.MainManageSeries?JSON.parse(data.MainManageSeries):JSON.parse('[]')
                    data.MainManageAutoParts = data.MainManageAutoParts?JSON.parse(data.MainManageAutoParts):JSON.parse('[]');
                    this.chosenShopMsg = data
                })
            },
            // 添加单个标记点
            addMaker(location){
                var that = this
                var latLng=new qq.maps.LatLng(location.lat,location.lng)
                var marker= new qq.maps.Marker({
                    position:latLng,
                    map:that.map
                });
                marker.setMap(that.map);
                marker.setPosition(latLng)
            },
            // 设置地图中心
            setMapCenter(lat,lng){
                this.map.panTo(new qq.maps.LatLng(lat,lng))
            },
            // 查看车主发来的地址
            seeAddress(){
                let that = this
                this.markerLocation = that.locationMsg
                that.center = new qq.maps.LatLng(this.locationMsg.latitude,this.locationMsg.longitude);
                that.map = new qq.maps.Map(document.getElementById("container"),{
                    center: that.center,
                    zoom: 13
                });
                var anchor = new qq.maps.Point(6, 6),
                    size = new qq.maps.Size(24, 24),
                    origin = new qq.maps.Point(0, 0),
                    icon = new qq.maps.MarkerImage('https://lbs.qq.com/javascript_v2/img/center.gif', size, origin, anchor);
                that.marker = new qq.maps.Marker({
                    icon:icon,
                    position: that.center,
                    map: that.map
                });
                qq.maps.event.addListener(that.map,'zoom_changed',function() {
                    var latlngs = that.latlngs
                    var data = that.shopList
                    var zoomLevel = that.map.getZoom();
                    if (zoomLevel >= 12){
                        for(var i = 0;i < latlngs.length; i++) {
                            (function(n){
                                that.infoWin = new qq.maps.InfoWindow({
                                    map: that.map,
                                    visible:true,
                                });
                                var marker = new qq.maps.Marker({
                                    position: latlngs[n],
                                    map: that.map
                                });
                                that.infoWin.open();
                                that.infoWin.setContent(`<div onclick="showShopDetails('${data[n].entpId}')"><div>${data[n].entpName}</div><div style="width: 80px;height: 40px;text-align: center"><img style="max-width: 80px;max-height: 40px" src="${that.downUrl+data[n].logoUrl}" alt=""></div></div>`);
                                that.infoWin.setPosition(latlngs[n]);
                            })(i);
                        }
                    }
                    else {
                        // for(let i = 0;i < latlngs.length; i++) {
                        //     (function(n){
                        //         that.infoWin = new qq.maps.InfoWindow({
                        //             map: that.map,
                        //             visible:false,
                        //         });
                        //         var marker = new qq.maps.Marker({
                        //             position: latlngs[n],
                        //             map: that.map
                        //         });
                        //         that.infoWin.close();
                        //         that.infoWin.setContent(`<div onclick="showShopDetails('${data[n].entpId}')"><div>${data[n].entpName}</div><div style="width: 80px;height: 40px;text-align: center"><img style="max-width: 80px;max-height: 40px" src="${that.downUrl+data[n].logoUrl}" alt=""></div></div>`);
                        //         that.infoWin.setPosition(latlngs[n]);
                        //     })(i);
                        // }
                    }

                });
                that.getNearby()
            },
            // 客服主动发送地址展示
            sendAddress(){
                let that = this
                that.center = new qq.maps.LatLng(39.916527,116.397128);
                that.map = new qq.maps.Map(document.getElementById("container"),{
                    center: that.center,
                    zoom: 13
                });
                //获取城市列表接口设置中心点
                that.citylocation = new qq.maps.CityService({
                    complete:(result)=>{
                        that.map.setCenter(result.detail.latLng);
                    }
                });
                //调用searchLocalCity();方法    根据用户IP查询城市信息。
                that.citylocation.searchLocalCity();

                //添加监听事件   获取鼠标单击事件
                qq.maps.event.addListener(that.map, 'click', function(event) {
                    that.getAddressText(event.latLng)
                    var marker=new qq.maps.Marker({
                        position:event.latLng,
                        map:that.map
                    });
                    qq.maps.event.addListener(that.map, 'click', function(event) {
                        marker.setMap(null);
                    });
                });
            },
            // 地址解析（搜索地址）
            getAddressLoction(){
                this.$util.axiosGet({
                    url:'/map/ws/geocoder/v1',
                    data:{
                        address:this.addressText,
                        key:'FLUBZ-ENY36-FNGSU-EIZIM-6FJWS-SYBKL'
                    },
                    map:true,
                    exception:true,
                }).then((res)=>{
                    // console.log(res)
                }).catch((err)=>{
                    // 不知道我sb还是腾讯地图sb还是axios sb 明明正常返回他就要进catch
                    // console.log(err)
                    if(err.data.status == 0){
                        let result = err.data.result
                        this.addMaker(result.location)
                        this.setMapCenter(result.location.lat,result.location.lng)
                        this.markerLocation = {
                            latitude: result.location.lat,
                            longitude: result.location.lng,
                            address:result.address_components.province + result.address_components.city + result.address_components.district + result.address_components.street + result.address_components.street_number,
                            name:this.addressText
                        }
                    }
                    else {
                        this.$util.warningMsg(err.data.message)
                    }
                })
            },
            // 地址逆解析
            getAddressText(location){
                this.$util.axiosGet({
                    url:'/map/ws/geocoder/v1/',
                    data:{
                        location:`${location.lat},${location.lng}`,
                        key:'FLUBZ-ENY36-FNGSU-EIZIM-6FJWS-SYBKL'
                    },
                    map:true,
                    exception:true,
                }).then((res)=>{
                    // console.log(res)
                }).catch((err)=>{
                    // 不知道我sb还是腾讯地图sb还是axios sb 明明正常返回他就要进catch
                    // console.log(err)
                    let result = err.data.result
                    this.markerLocation = {
                        latitude: result.location.lat,
                        longitude: result.location.lng,
                        address:result.address,
                        name:result.formatted_addresses.rough
                    }
                })
            },
            // 获取附近的门店
            getNearby(){
                let that = this
                this.$util.axiosPost({
                    url:'/api/Map/GetEntp',
                    data:{
                        "longitude": this.markerLocation.longitude,
                        "latitude": this.markerLocation.latitude,
                        "distance": 10,
                    }
                }).then((res)=>{
                    let data = res.data
                    let latlngs = []
                    for(let i=0;i<data.length;i++){
                        latlngs.push(new qq.maps.LatLng(data[i].latitude,data[i].longitude))
                    }
                    that.latlngs = latlngs
                    that.shopList = data

                    // 默认显示所有标注
                    // for(var i = 0;i < latlngs.length; i++) {
                    //     (function(n){
                    //         var infoWin = new qq.maps.InfoWindow({
                    //             map: that.map,
                    //             visible:true,
                    //         });
                    //         var marker = new qq.maps.Marker({
                    //             position: latlngs[n],
                    //             map: that.map
                    //         });
                    //         infoWin.open();
                    //         infoWin.setContent(`<div onclick="showShopDetails('${data[n].entpId}')"><div>${data[n].entpName}</div><div style="width: 80px;height: 40px;text-align: center"><img style="max-width: 80px;max-height: 40px" src="${that.downUrl+data[n].logoUrl}" alt=""></div></div>`);
                    //         infoWin.setPosition(latlngs[n]);
                    //     })(i);
                    // }

                    // 点击显示标注
                    that.infoWin = new qq.maps.InfoWindow({
                        map: that.map,
                        visible:true,
                    });
                    for(var i = 0;i < latlngs.length; i++) {
                        (function(n){
                            var marker = new qq.maps.Marker({
                                position: latlngs[n],
                                map: that.map
                            });
                            qq.maps.event.addListener(marker, 'click', function() {
                                that.infoWin.open();
                                that.infoWin.setContent(`<div onclick="showShopDetails('${data[n].entpId}')"><div>${data[n].entpName}</div><div style="width: 80px;height: 40px;text-align: center"><img style="max-width: 80px;max-height: 40px" src="${that.downUrl+data[n].logoUrl}" alt=""></div></div>`);
                                that.infoWin.setPosition(latlngs[n]);
                            });
                        })(i);
                    }
                })
            },
        }
    }
</script>
<style lang="less" scoped>
    .search-ctn {
        display: flex;
        padding-bottom: 20px;
    }
    #container {
        width: 750px;
        height: 450px;
    }
    .dialog-footer {
        padding-top: 20px;
        text-align: right;
    }
    .address-text {
        font-size: 16px;
        padding-bottom: 10px;
    }
    .dialog-content {
        max-height: 500px;
        overflow: auto;
    }
    .s0-1 {
        display: flex;
        justify-content: space-between;
    }
    .up-logo {
        width: 220px;
        text-align: center;
    }

    .preview {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 200px;
        height: 250px;
        border: 1px solid @border4Color;
        border-radius: 10px;
        display: flex;
        align-items: center;
        overflow: hidden;
        img {
            max-width: 200px;
            max-height: 200px;
        }
    }

    .btn-upload {
        width: 200px;
        margin-top: 20px;
    }

    .formData {
        width: 650px;
    }

    .company-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
    }

    .company-name {
        font-size: @font-lg;
    }

    .msg-line {
        display: flex;
        line-height: 36px;
        justify-content: space-between;
        border-bottom: 1px dashed @border4Color;
    }

    .msg-cell {
        width: 550px;
        display: flex;
        .key {
            width: 150px;
            text-align: right;
            padding-right: 20px;
            flex-shrink: 0;
        }
        .value {
            a {
                color: #606266;
            }
        }
        i {
            margin-right: 10px;
        }
    }
    .quill-editor {
        height: 200px;
    }
    .companyIntr-title {
        font-size: @font-md;
        margin-bottom: 20px;
    }
    .companyIntr-content {
        text-indent: 2em;
        line-height: 1.5em;
    }
    .carType-ctn {
        border: 1px solid #dcdfe6;
        border-radius: 5px;
        min-height: 40px;
        padding: 10px;
        display: flex;
        flex-wrap:wrap;
        align-items: center;
    }
    .carTypeItem {
        padding: 0 5px;
        height: 24px;
        line-height: 24px;
        border: 1px solid @theme;
        color: @theme;
        margin: 5px;
    }
    .carTypeItem-show {
        display: inline-block;
    }
    .el-tag + .el-tag {
        margin-left: 10px;
    }
    .button-new-tag {
        margin-left: 10px;
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }
    .input-new-tag {
        width: 90px;
        margin-left: 10px;
        vertical-align: bottom;
    }
</style>
